import {Button} from '@travel-frontend/ui-components';
import {useTranslation} from 'react-i18next';

import {Container} from '@/modules/hotels/components/MapView/components/NoResultsMessage/components/Container';

type Props = {
  onClickFilterResetButton?: () => void;
};

export const NoResultsMessage: React.FunctionComponent<Props> = ({
  onClickFilterResetButton,
}) => {
  const {t} = useTranslation('filters');
  const withFilters = Boolean(onClickFilterResetButton); // @FIXME

  return (
    <Container
      variant="warning"
      caption={t(
        withFilters
          ? 'noResults.hotels.title.withFilters'
          : 'noResults.hotels.title.default'
      )}
      controls={
        onClickFilterResetButton && (
          <Button
            variant="warning"
            fullWidth
            onClick={onClickFilterResetButton}
          >
            {t('noResults.buttons.clearAllFilters')}
          </Button>
        )
      }
    >
      {t(
        withFilters
          ? 'noResults.message.withFilters'
          : 'noResults.message.default'
      )}
    </Container>
  );
};
